import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SideDrawer from "../../../../Components/sideDrower/SideDrawer";
import { FaStar } from "react-icons/fa";
import { MdContactPage } from "react-icons/md";
import { BsIncognito } from "react-icons/bs";
import { groupPreferenceApi } from "../../../../services/groups";
import { toastMessage } from "../../../../utils/toastMessage";
import "./GroupSetting.css";

const GroupSetting = ({
  groupSettingModal,
  setGroupSettingModal,
  groupDetail,
  setGroupDetail,
  listing = () => { }
}) => {
  const [settings, setSettings] = useState({});

  // Initialize local settings from groupDetail
  useEffect(() => {
    setSettings({
      showAdminBadge: groupDetail?.settings?.showAdminBadge || false,
      showGroupTag: groupDetail?.settings?.showGroupTag || false,
      anonymousPosting: groupDetail?.settings?.anonymousPosting || false,
      approveFirstPost: groupDetail?.settings?.approveFirstPost || false,
    });
  }, [groupDetail?.settings]);

  // Handle checkbox change
  const handleCheckbox = async (e) => {
    const { name, checked } = e.target;
    const updatedSettings = { ...settings, [name]: checked };

    try {
      const { data } = await groupPreferenceApi({
        _id: groupDetail?._id,
        settings: updatedSettings,
      });

      const { success, message } = data;
      if (success) {
        setSettings(updatedSettings);
        setGroupDetail((prevGroupDetail) => ({
          ...prevGroupDetail,
          settings: updatedSettings,
        }));
        setTimeout(() => {
          listing()
        }, 1000)
        toastMessage(message, "success", "updateGroupSetting");
      } else {
        toastMessage(message, "error", "updateGroupSetting");
      }
    } catch (error) {
      console.error("Error updating settings:", error.message);
      toastMessage("Failed to update settings. Please try again.", "error");
    }
  };


  // console.log(groupDetail,"groupDetail");

  return (
    <SideDrawer
      show={groupSettingModal}
      handleClose={() => setGroupSettingModal(false)}
    >
      <div className="group_setting_parent">
        <div className="group_setting_child">
          <h3 className="drawer_title">Group Setting</h3>
          <p className="manage_txt">
            Manage your group preferences and settings.
          </p>
        </div>

        <div className="group_setting_content">
          {/* Show Admin Badge */}
          <div className="setting-item">
            <div className="icon-wrapper">
              <FaStar className="icon" />
            </div>
            <div className="content">
              <Link to="/dashboard/group/groupRequestDrawer/Send_Msg_Req">
                <h3 className="title">Badges</h3>
              </Link>
              <p className="description">
                Enable this option to show the 'Group Admin' badge next to the
                admin's name in the members list.
              </p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                className="toggle-input"
                name="showAdminBadge"
                checked={settings?.showAdminBadge}
                onChange={handleCheckbox}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          {/* Show Group Tag */}
          <div className="setting-item">
            <div className="icon-wrapper">
              <MdContactPage className="icon" />
            </div>
            <div className="content">
              <h3 className="title">Show Group Tag</h3>
              <p className="description">
                Enable to display the group's category tags (e.g., Tech,
                Fitness, etc.) to members.
              </p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                className="toggle-input"
                name="showGroupTag"
                checked={settings?.showGroupTag}
                onChange={handleCheckbox}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          {/* Anonymous Posting */}
          <div className="setting-item">
            <div className="icon-wrapper">
              <BsIncognito className="icon" />
            </div>
            <div className="content">
              <h3 className="title">Anonymous Posting</h3>
              <p className="description">
                Allow members to post anonymously. Their names will be hidden
                from others in the group.
              </p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                className="toggle-input"
                name="anonymousPosting"
                checked={settings?.anonymousPosting}
                onChange={handleCheckbox}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>

          {/* Approve First Post */}
          <div className="setting-item">
            <div className="icon-wrapper">
              <svg
                className="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="content">
              <h3 className="title">Approve First Post</h3>
              <p className="description">
                Approve member posts before they appear in the group. Disable to
                allow automatic posting.
              </p>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                className="toggle-input"
                name="approveFirstPost"
                checked={settings?.approveFirstPost}
                onChange={handleCheckbox}
              />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </SideDrawer>
  );
};

export default GroupSetting;
